import { useState, MouseEvent } from 'react';

import { Skeleton, Typography } from '@mui/material';
import ListSubheader from '@mui/material/ListSubheader';
import Menu from '@mui/material/Menu';
import scssVariables from '@styles/variables.module.scss';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import styles from './BookmarksMenu.module.scss';
import { DefaultMenuItem } from '@/components/ui/DefaultMenuItem';
import { IconButton } from '@/components/ui/IconButton';
import { uiIcons } from '@/constants/uiIcons';
import { useGetBookmarkAPI as useLegacyGetBookmarkAPI } from '@/legacy/apis/bookmarksAPI';
/* 
 NOT FULLY REFACTORED
 TODO: Make use of new API for fetching bookmarks
*/
export const BookmarksMenu = () => {
  const { t } = useTranslation('header');

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { bookmarks, isSuccess, isLoading } = useLegacyGetBookmarkAPI();

  return (
    <div>
      <IconButton
        size="small"
        id="bookmarks-menu-button"
        color="secondary"
        aria-controls={open ? 'bookmarks-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open}
        onClick={handleOpen}
        selected={open}
        data-automation-id="TopBarBookmarksButton"
        iconName={uiIcons.actions.bookmark}
        tooltip={t('PrimaryNavigationBookmark')}
        iconProps={{ color: scssVariables.ColorBlack100 }}
      />
      <Menu
        className={styles.BookmarksMenu}
        id="bookmarks-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            component: 'nav',
            disablePadding: true,
            'aria-labelledby': 'bookmarks-menu-button',
          },
        }}
      >
        <ListSubheader disableGutters component="div">
          {t('PrimaryNavigationBookmark')}
        </ListSubheader>
        {isLoading ? <Skeleton width="96px" /> : null}
        {isSuccess && bookmarks.length === 0 ? (
          <Typography>{t('PrimaryNavigationBookmarkEmptyState')}</Typography>
        ) : null}
        {isSuccess && bookmarks.length > 0
          ? bookmarks.map((bookmark) => (
              <DefaultMenuItem
                key={bookmark.id}
                component={NavLink}
                to={bookmark.url}
                onClick={handleClose}
                data-automation-id={`bookmarks-menu-item-${bookmark.name}`}
              >
                {bookmark.name}
              </DefaultMenuItem>
            ))
          : null}
      </Menu>
    </div>
  );
};
